import { useContext } from 'react';

import { RolesDetailsContext } from '@shared/providers/RolesDetailsProvider/providerSetup.ts';

export const useRolesDetailsContext = () => {
  const context = useContext(RolesDetailsContext);

  return context;
};
